export const FETCH_ACCOUNT_DETAILS = "FETCH_ACCOUNT_DETAILS"
export const SIGN_OUT = "SIGN_OUT"
export const CHECK_REGISTRATION_CODE = "CHECK_REGISTRATION_CODE"